<template>
    <div>
        <h2 style="cursor:pointer" @click="_setInterval()" id="countdown2">Tiempo{{ countdown }}</h2>
    </div>
</template>

<script>
    import * as moment from 'moment';
    export default {
        name: 'CountDown',
        props: {
            seconds: {
                type: Number,
                required: true,
            }
        },
        data () {
            return {
                countdown: null,
                expires_in: null,
                interval: null,
                Clickinterval: false,
            }
        },
        mounted () {
            this.countdown = moment.utc(32).format('HH:mm:ss');
            this.expires_in = 32;
            // this._setInterval();
        },
        destroyed () {
            clearInterval(this.interval);
        },
        methods: {
            _setInterval: function() {
                if(this.Clickinterval==false){
                    this.interval = setInterval(() => {
                        if (this.expires_in === 0) {
                            clearInterval(this.interval);
                        } else {
                            this.expires_in -= 1;
                            if(this.expires_in>0){
                                this.countdown = moment.utc(this.expires_in * 1000).subtract(1, 'seconds').format('HH:mm:ss');
                            }else{
                                this.terminoTiempo();
                            }
                        }
                    }, 1000);
                    this.Clickinterval = true;
                }
            },
            terminoTiempo(){
                alert("Se acabo el tiempo para responder las preguntas")
            }
        }
    }
</script>
<style>
    #countdown2 {
        font-size:30px;
        color:#00579e;
    }
</style>